import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useMemo } from "react";

import { AppPageContent } from "@/components/layout/app-page";
import { PageHeader } from "@/components/ui/page-header";
import { TabNav } from "@/components/ui/tab-nav";
import { useCurrentUser } from "@/hooks/use-current-account";

export const Route = createFileRoute("/_authenticated/app/admin")({
  component: AdminSettingsLayout,
});

function AdminSettingsLayout() {
  const { data: user } = useCurrentUser();

  const tabs = useMemo(
    () =>
      [
        { to: "/app/admin" as const, label: "Organization" },
        { to: "/app/admin/setup" as const, label: "Setup" },
        { to: "/app/admin/communication" as const, label: "Communication" },
        { to: "/app/admin/data-privacy" as const, label: "Data & Privacy" },
        { to: "/app/admin/roles" as const, label: "People" },
        { to: "/app/admin/tags" as const, label: "Tags" },
      ] as const,
    [],
  );

  if (user && user.role !== "company_admin") {
    return null;
  }

  return (
    <AppPageContent variant="medium">
      <div className="mx-auto w-full max-w-180">
        <PageHeader title="Organization Settings" />

        <TabNav tabs={tabs} variant="inline" />

        <Outlet />
      </div>
    </AppPageContent>
  );
}
